import angular from 'angular';

import {} from './task.styles.scss';

import MonitoringTaskController from './task.controller';
import TasksService from './task.service';

export default angular.module('autoboard.monitoringTask', [TasksService])
  .controller('MonitoringTaskController', MonitoringTaskController)
  .name;
